import { AuthenticationData } from "@directus/sdk";
import { AuthCodeLoginResponseSuccess } from "~/entities/authentication";

export function castCodeAuthResultToAuthData(
  dto: AuthCodeLoginResponseSuccess,
): AuthenticationData {
  return {
    access_token: dto.accessToken,
    refresh_token: dto.refreshToken,
    expires: dto.expires,
    expires_at: dto.expiresAt,
  };
}
